import { useState } from 'react';

import { Button, Form, Input } from 'antd';

import { NotificationsTypes } from '@/interfaces/notificationsTypes';
import { useUpdateUserMutation } from '@/services/user';
import styled, { css, StyledProp } from '@/styled';

interface PasswordStudentProps extends StyledProp {
  name: string;
  email: string;
  type: number;
  avatar?: string;
  notification: (message: string, type: NotificationsTypes) => void;
}

const PasswordStudent = ({ className, name, email, type, avatar, notification }: PasswordStudentProps) => {
  const [form] = Form.useForm();
  const [isDirty, setIsDirty] = useState(true);

  const [updateProfile, { isLoading }] = useUpdateUserMutation();

  const savePassword = async (values: any) => {
    try {
      setIsDirty(false);

      await updateProfile({
        currentpass: values.currentPassword,
        password: values.newPassword,
        confirmPassword: values.confirmPassword,
        name,
        email,
        type,
        avatar
      });
      notification('Senha atualizada com sucesso', NotificationsTypes.SUCCESS);
    } catch {
      notification('Ocorreu um erro ao atualizar senha', NotificationsTypes.ERROR);
    }

    form.resetFields();
    setIsDirty(true);
  };

  return (
    <div className={className}>
      <Form form={form} layout='vertical' size='large' autoComplete='off' onFinish={savePassword}>
        <Form.Item
          label='Senha Atual'
          name='currentPassword'
          hasFeedback
          rules={[{ required: true, message: 'Digite a sua senha atual' }]}
        >
          <Input.Password placeholder='Digite a sua senha atual aqui' />
        </Form.Item>
        <Form.Item
          label='Nova Senha'
          name='newPassword'
          hasFeedback
          rules={[{ required: true, message: 'Digite sua nova senha' }]}
        >
          <Input.Password placeholder='Digite sua nova senha aqui' />
        </Form.Item>
        <Form.Item
          label='Confirme sua nova senha'
          name='confirmNewPassword'
          dependencies={['newPassword']}
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Confirme sua senha'
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }

                return Promise.reject(new Error('As duas senha não são iguais!'));
              }
            })
          ]}
        >
          <Input.Password placeholder='Confirme sua senha aqui' />
        </Form.Item>
        <Form.Item>
          <Button
            disabled={!isDirty}
            loading={isLoading}
            type='primary'
            size='large'
            className='password-student-btn'
            htmlType='submit'
          >
            Alterar Senha
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default styled(PasswordStudent)(
  ({ theme }) => css`
    .password-student-btn {
      background-color: ${theme.colorText};
      margin-top: ${theme.space.spacing(4)};

      ${theme.breakpoints.down('md')} {
        width: 100%;
      }

      &:disabled {
        color: ${theme.colorBgLayout};
      }
    }

    [title='Senha Atual'],
    [title='Nova Senha'],
    [title='Confirme sua nova senha'] {
      color: ${theme.colorTextSecondary} !important;
    }
  `
);
